<template>
  <v-dialog v-model="visible" max-width="600">
    <v-card>
      <v-card-title class="text-h6">ようこそ Poranos へ</v-card-title>
      <v-card-text class="text-body-1" style="white-space: pre-wrap">
        <div class="modal-content">
          <p>
            Poranosは、XRで3Dモデルやボリュメトリックビデオ（立体映像）を共有する、シンプルで使いやすいプラットフォームです。
          </p>
          <p>
            <strong>ゲストとして利用する場合、以下の制限があります：</strong>
          </p>
          <ul>
            <li>ルームは <strong>5個</strong> まで作成できます。</li>
            <li>
              ファイルは <strong>50個</strong>、合計
              <strong>10GB以下</strong> までアップロードできます。
            </li>
            <li>
              アップロードしたファイルは
              <strong>10時間後に自動削除</strong> されます。
            </li>
          </ul>
          <p>
            著作権に違反するもの、他者の迷惑になるコンテンツのアップロードはご遠慮ください。
          </p>
          <p>
            Meta Quest 3 用の Poranos
            アプリでルームに参加できますが、<strong>共有ルーム</strong>のため、他のユーザーが同じ空間にいることがあります。ご注意ください。
          </p>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="close">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, onMounted } from "vue";

const visible = ref(false);

const close = () => {
  visible.value = false;
  //   localStorage.setItem("guestWelcomeShown", "true");
};

onMounted(() => {
  //   const isGuest = localStorage.getItem("isGuest") === "true";
  //   const alreadyShown = localStorage.getItem("guestWelcomeShown") === "true";
  //   if (isGuest && !alreadyShown) {
  visible.value = true;
  //   }
});
</script>
<style scoped>
.modal-content {
  font-size: 15px;
  line-height: 1.6;
}
.modal-content ul {
  padding-left: 1.5rem;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}
.modal-content li {
  margin-bottom: 0.4rem;
}
</style>
